export const ROW_HEIGHT = 40;

export const DEFAULT_COL_WIDTH = 120;

export const MIN_COL_WIDTH = 60;

export const OVERSCAN = 10;

export function getScrollParent(node) {
  if (!node || node === document.body) {
    return globalThis.window;
  }

  const { overflowY, overflow } = globalThis.window.getComputedStyle(node);

  if (/(auto|scroll)/.test(overflowY + overflow)) {
    return node;
  }

  return getScrollParent(node.parentElement);
}

export function buildRows(columns, columnTitles) {
  if (!columnTitles.length) {
    return [];
  }

  const len = columns[columnTitles[0]].length;

  return Array.from({ length: len }, (_, i) => {
    const row = {};

    columnTitles.forEach(t => {
      row[t] = columns[t][i];
    });

    return row;
  });
}

export function rebalanceWidths(prev, title, newWidth, containerWidth) {
  if (!containerWidth) {
    return prev;
  }

  const otherTitles = Object.keys(prev).filter(t => t !== title);
  const clamped = Math.max(
    MIN_COL_WIDTH,
    Math.min(containerWidth - otherTitles.length * MIN_COL_WIDTH, newWidth),
  );
  const available = containerWidth - clamped;
  const otherTotal = otherTitles.reduce((sum, t) => sum + prev[t], 0);
  const result = { ...prev, [title]: clamped };
  let allocated = 0;

  otherTitles.forEach((t, idx) => {
    if (idx === otherTitles.length - 1) {
      result[t] = Math.max(MIN_COL_WIDTH, available - allocated);
    } else {
      const w =
        otherTotal > 0
          ? Math.max(MIN_COL_WIDTH, Math.round((prev[t] / otherTotal) * available))
          : Math.max(MIN_COL_WIDTH, Math.floor(available / otherTitles.length));

      result[t] = w;
      allocated += w;
    }
  });

  return result;
}

export function scaleWidths(prev, newWidth) {
  const titles = Object.keys(prev);
  const result = { ...prev };
  const scaleFactor = newWidth / Object.values(prev).reduce((a, b) => a + b, 0);
  let allocated = 0;

  titles.forEach((t, idx) => {
    if (idx === titles.length - 1) {
      result[t] = Math.max(MIN_COL_WIDTH, newWidth - allocated);
    } else {
      const w = Math.max(MIN_COL_WIDTH, Math.round(prev[t] * scaleFactor));

      result[t] = w;
      allocated += w;
    }
  });

  return result;
}
